import React from 'react';
import { Table, TableBody, TableRow, TableCell } from '@mui/material';
import SortableTableHeader from '../CustomComponents/SortableTableHeader';
import { useTableSort, getComparator } from '../../utils/tableSorting';
import { formatCurrency, formatPercentage } from '../../utils/formatNumbers';
import { useNavigate } from 'react-router';

const ITEM_HEADERS = [
    { id: 'name',                 label: 'Item',                ratio: 22, tooltip: '' },
    { id: 'vendor_name',          label: 'Vendor',              ratio: 15, tooltip: '' },
    { id: 'average_item_spend',   label: 'Avg. Spend',           ratio: 13, justify: 'end', tooltip: 'Average spend per case for this item' },
    { id: 'average_item_quantity', label: 'Avg. Used',            ratio: 10, justify: 'end', tooltip: 'Average quantity used per case' },
    { id: 'card_prevalence',      label: 'Card Prevalence',     ratio: 13, justify: 'end', tooltip: '% of cards that include this item' },
    { id: 'case_prevalence',      label: 'Case Prevalence',     ratio: 13, justify: 'end', tooltip: '% of cases in which this item was used' },
];

function CategoryItemTable({ items, procedureId }) {
    const { order, orderBy, handleRequestSort } = useTableSort('case_prevalence', 'desc');
    const sorted = [...items].sort(getComparator(order, orderBy));
    const navigate = useNavigate();

    return (
        <Table size="small">
            <SortableTableHeader
                headers={ITEM_HEADERS}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
            />
            <TableBody>
                {sorted.map((item) => (
                    <TableRow key={item.item_id} onClick={() => navigate(`/procedures/${procedureId}/items/${item.item_id}`)} hover>
                        <TableCell>{item.name}</TableCell>
                        <TableCell sx={{ color: 'text.secondary' }}>{item.vendor_name}</TableCell>
                        <TableCell align="right">{formatCurrency(item.average_item_spend)}</TableCell>
                        <TableCell align="right">{item.average_item_quantity?.toFixed(1)}</TableCell>
                        <TableCell align="right">{formatPercentage(item.card_prevalence)}</TableCell>
                        <TableCell align="right">{formatPercentage(item.case_prevalence)}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}

export default CategoryItemTable;
